import React from "react";
import "./about.css";

const TopSection = () => {
  return (
    <div className="container">
      <div className="top_section">
        <div className="about_title">
          <h1>About Us</h1>
        </div>
        <div>
          <div className="company-title">
            <img
              src="/images/about_images/logo/newlogo3.svg"
              alt="CWPC"
              id="cwpc_logo"
            />
            <h5>
              Catastrophic Wildfire Prevention Consortium (CWPC) at CrowdDoing
            </h5>
          </div>
          <div className="info">
            <p>
              The Catastrophic Wildfire Prevention Consortium (CWPC) unites
              global experts, startups, and institutions, to combat catastrophic
              wildfires through prevention, mitigation, and innovation. Our
              consortium converts the potential costs of inactions into
              investments in preventative actions to make communities safer,
              more resilient and regenerative.
            </p>
            <br></br>
            <p>
              Learn more about{" "}
              <a
                href="/"
                aria-label="Link to learn more Catastrophic Wildfire Prevention"
              >
                CWPC
              </a>
            </p>
          </div>
        </div>
        <div>
          <div className="company-title">
            <img
              src="/images/about_images/logo/cd-logo.png"
              alt="CWPC"
              id="cwpc_logo"
            />
            <h5>CrowdDoing</h5>
          </div>
          <div className="info">
            <p>
              CrowdDoing (CD) is a joint initiative of the Match4Action
              Foundation and ReframeIt, focused on addressing the social,
              economic, and environmental challenges our world faces by
              collaborating with professionals and volunteers from many
              different industries. CD aims to support social innovations with
              transformative impact potential through global multi-disciplinary
              volunteering, micro-leadership and service learning.
            </p>
            <br></br>
            <p>
              Learn more about{" "}
              <a
                href="http://crowddoing.world"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Link to navigate to CrowdDoing dot world"
              >
                CrowdDoing
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
